var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[(_vm.songs.length > 0)?_c('router-view',{attrs:{"title":_vm.title,"body":_vm.body,"hashtag":_vm.hashtag,"songs":_vm.songs}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }